import styled from "styled-components";

const Container = styled.div`
    visibility: hidden;
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(36, 36, 36, 0.85);
    z-index: 100;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: scroll;
    opacity: 0;
    transition: all 0.2s ease-in;

    &.open {
        visibility: visible;
        opacity: 1;
    }

    .content {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;

        .backdrop {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 1;
        }

        .media {
            z-index: 2;
            text-align: center;

            img {
                max-width: 100%;
                max-height: 70vh;
            }

            video {
                max-width: 100%;
                max-height: 70vh;
            }

            p {
                margin-top: 13px;
            }

            .close {
                text-align: right;
                margin-bottom: 10px;
            }
        }

        .prev,
        .next {
            padding: 15px;
            z-index: 3;
        }

        .filename {
            color: white;
            font-size: 14px;
        }
    }

    .mobile {
        z-index: 4;
        display: none;
    }

    @media (max-width: 900px) {
        .content {
            flex-direction: column;
            padding: 10px;
        }

        .mobile {
            display: block;
            text-align: center;

            button {
                margin: 10px 4px;
            }
        }

        .prev,
        .next,
        .media .filename {
            display: none;
        }
    }
`;

export default Container;
